import { useState } from 'react';
import { Drawer, FloatButton } from 'antd';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { Accordion, AccordionBody, AccordionHeader, AccordionList } from '@tremor/react'
import Help from '../Types/Help';

const HelpInfos = (props: { helpInfo: Help }) => {
    const [open, setOpen] = useState(false);

    const showLargeDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <FloatButton icon={<ContactSupportIcon />} onClick={showLargeDrawer} shape="circle" />
            <Drawer className='Helpcenter' title={'Help Info'} placement="right" size={'large'} onClose={onClose}
                open={open}>
                <AccordionList>
                    <Accordion>
                        <AccordionHeader className="text-md font-medium text-tremor-content-strong dark:text-dark-tremor-content-strong">
                            {props.helpInfo.Titre}
                        </AccordionHeader>
                        <AccordionBody className="leading-6">
                            {props.helpInfo.Description}
                            {props.helpInfo.SousHelp.map((datass: Help, index: number) => (
                                <Accordion key={index}>
                                    <AccordionHeader className="text-md font-medium text-tremor-content-strong dark:text-dark-tremor-content-strong">
                                        {datass.Titre}
                                    </AccordionHeader>
                                    <AccordionBody className="leading-6">
                                        {datass.Description}
                                    </AccordionBody>
                                </Accordion>))}
                        </AccordionBody>
                    </Accordion>
                </AccordionList>
            </Drawer>
        </div>
    )
}

export default HelpInfos;
